const Delete = ({ classname }) => (
	<svg
		fill='none'
		height='24'
		viewBox='0 0 17 16'
		width='24'
		className={classname ? classname : ''}
	>
		<path
			d='M5.16669 14C4.80002 14 4.48624 13.8696 4.22535 13.6087C3.96446 13.3478 3.8338 13.0338 3.83335 12.6667V4H3.16669V2.66667H6.50002V2H10.5V2.66667H13.8334V4H13.1667V12.6667C13.1667 13.0333 13.0362 13.3473 12.7754 13.6087C12.5145 13.87 12.2005 14.0004 11.8334 14H5.16669ZM6.50002 11.3333H7.83335V5.33333H6.50002V11.3333ZM9.16669 11.3333H10.5V5.33333H9.16669V11.3333Z'
			fill='currentColor'
		/>
	</svg>
)
export default Delete
